module.exports = ".btn:hover {\n  background-color: #311eaa;\n  color: #C9FF27; }\n\n.btn-outline,\n.btn-danger,\n.btn-success {\n  color: #4A12F0;\n  border-color: #4A12F0;\n  background-color: #FFFFFF;\n  font-weight: bold;\n  border-radius: 60px; }\n\n.btn:hover {\n  background-color: #311eaa;\n  color: #C9FF27; }\n\n.btn.btn-outline,\n.btn.btn-danger,\n.btn.btn-success,\n.btn-outline,\n.btn-danger,\n.btn-success {\n  color: #4A12F0;\n  border-color: #4A12F0;\n  background-color: #FFFFFF;\n  font-weight: bold;\n  border-radius: 60px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/common/modal/modal.component.scss
// module id = ./src/app/common/modal/modal.component.scss
// module chunks = main